import { useState } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { restrictedCountries } from '../constants';

export const useIsUserFromRestrictedCountry = (): boolean => {
    const { countryCode } = getContext();
    const [isFromRestrictedCountry] = useState(restrictedCountries.includes(countryCode));
    return isFromRestrictedCountry;
};
